/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize RolesManagement View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './rolesManagementView';

export const mapStateToPropsRoleManagement = mapStateToProps;
export const mapDispatchToPropsRoleManagement = mapDispatchToProps;

export default connect(
  mapStateToPropsRoleManagement,
  mapDispatchToPropsRoleManagement
)(View);
